import * as Types from '../types-api.generated';

import { BookmarkFragment, MomentOverviewFragment, MomentFragment, UserLightFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiMomentBookmarksVariables = Types.Exact<{
  publicKey: Types.Scalars['String'];
  timeFrame?: Types.InputMaybe<Types.ApiBookmarkTimeFrame>;
  page: Types.Scalars['Int'];
  perPage: Types.Scalars['Int'];
}>;


export type ApiMomentBookmarks = { momentBookmarks: { totalItems: number, page: number, totalPages: number, items: Array<{ id: string, publicKey: string, createdAt: string, content: { id: number, name: string, description: string | null, worldId: number, posterUrl: string, startsAt: string, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } } }> } };



export const ApiMomentBookmarksDocument = /*#__PURE__*/ `
    query MomentBookmarks($publicKey: String!, $timeFrame: BookmarkTimeFrame, $page: Int!, $perPage: Int!) {
  momentBookmarks(
    publicKey: $publicKey
    timeFrame: $timeFrame
    page: $page
    perPage: $perPage
  ) {
    totalItems
    page
    totalPages
    items {
      ...BookmarkFragment
    }
  }
}
    ${BookmarkFragment}
${MomentOverviewFragment}
${MomentFragment}
${UserLightFragment}
${WorldOverviewFragment}`;

export const useMomentBookmarks = <
      TData = ApiMomentBookmarks,
      TError = ClientError
    >(
      variables: ApiMomentBookmarksVariables,
      options?: Omit<UseQueryOptions<ApiMomentBookmarks, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiMomentBookmarks, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiMomentBookmarks, TError, TData>(
      {
    queryKey: ['MomentBookmarks', variables],
    queryFn: apiFetcher<ApiMomentBookmarks, ApiMomentBookmarksVariables>(ApiMomentBookmarksDocument, variables),
    ...options
  }
    )};

useMomentBookmarks.getKey = (variables: ApiMomentBookmarksVariables) => ['MomentBookmarks', variables];

export const useInfiniteMomentBookmarks = <
      TData = InfiniteData<ApiMomentBookmarks>,
      TError = ClientError
    >(
      variables: ApiMomentBookmarksVariables,
      options: Omit<UseInfiniteQueryOptions<ApiMomentBookmarks, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiMomentBookmarks, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiMomentBookmarks, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MomentBookmarks.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiMomentBookmarks, ApiMomentBookmarksVariables>(ApiMomentBookmarksDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMomentBookmarks.getKey = (variables: ApiMomentBookmarksVariables) => ['MomentBookmarks.infinite', variables];


useMomentBookmarks.fetcher = (variables: ApiMomentBookmarksVariables, options?: RequestInit['headers']) => apiFetcher<ApiMomentBookmarks, ApiMomentBookmarksVariables>(ApiMomentBookmarksDocument, variables, options);
